<div class="animate-pulse">
  <!-- Question skeleton on the right side -->


  <div *ngFor="let item of skeletonItems" class="mb-4">
    <!-- Question skeleton on the right side -->
    <div class="text-right flex items-center justify-end mb-8">
      <div class="py-2 px-4 rounded-full bg-gray-100 w-1/2 h-10"></div>
    </div>

    <!-- Answer skeleton on the left side -->
    <div class="text-left flex items-center justify-start mb-8">
      <div class="flex items-center justify-start w-full">
        <div class="h-10 w-10 bg-gray-100 rounded-full mr-2"></div>
        <div class="py-2 px-4 rounded-lg bg-gray-100 w-1/2 h-16"></div>
      </div>
    </div>
  </div>
</div>